// Version control for cache busting
// This file manages app versioning and clears cache/cookies when a new version is deployed

const APP_VERSION_KEY = 'purolink_app_version';
// Fixed version - change this manually or via build process when deploying
const CURRENT_VERSION = '2026.02.10.1'; 

export const checkAndClearCache = () => {
  const storedVersion = localStorage.getItem(APP_VERSION_KEY);
  
  // If same version, do nothing
  if (storedVersion === CURRENT_VERSION) {
    return false;
  }
  
  console.log(`New version detected: ${CURRENT_VERSION} (was: ${storedVersion})`);
  
  // Clear all localStorage except essential items
  const essentialKeys = ['cookieConsent', APP_VERSION_KEY];
  const keysToRemove = [];
  
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!essentialKeys.includes(key)) {
      keysToRemove.push(key);
    }
  }
  
  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
  });
  
  // Clear sessionStorage
  sessionStorage.clear();
  
  // Clear all cookies except essential ones
  const cookies = document.cookie.split(';');
  cookies.forEach(cookie => {
    const cookieName = cookie.split('=')[0].trim();
    if (cookieName && cookieName !== 'cookieConsent') {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  });
  
  // Store new version BEFORE any reload
  localStorage.setItem(APP_VERSION_KEY, CURRENT_VERSION);
  
  // If there was a previous version (not first visit), force reload
  if (storedVersion) {
    console.log('Clearing cache and reloading for new version...');
    // Clear browser cache for this origin
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
    
    // Force reload from server (not from cache)
    window.location.reload(true);
    return true;
  }
  
  return false;
};

export const getCurrentVersion = () => CURRENT_VERSION;

export const forceVersionUpdate = () => {
  localStorage.removeItem(APP_VERSION_KEY);
  window.location.reload(true);
};
